import { render, staticRenderFns } from "./headerTitle.vue?vue&type=template&id=4fa2bab6&scoped=true&"
import script from "./headerTitle.vue?vue&type=script&lang=js&"
export * from "./headerTitle.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4fa2bab6",
  null
  
)

export default component.exports